import { ApiParameter, post, } from "@insite/client-framework/Services/ApiService";
import { RfqModel } from "@insite/client-framework/Types/ApiModels";

export interface CreateRfqApiParameter extends ApiParameter {
    rfq: RfqModel;
}

const rfqUrl = "/api/v1/hiscorfq/create";

export async function createRfq(parameter: CreateRfqApiParameter) {
    const uri = `${ rfqUrl }`;
    const rfq = parameter.rfq;
    const response = await post<RfqModel>(`${uri}`, rfq);
    return response;
}
